import React from 'react';
import { Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';

import LTCommonHeader from '@lambdatestincprivate/lt-common-header';
import Loader from 'components/Loader';
import Routes from '../../routes';
import history from 'utils/history';

import CustomHeader from './components/custom-header';

import usePlan from 'hooks/usePlan';
import AppBannerAndModals from './modals';
import { ParallelMessage } from 'constants/app';
// import ErrorBoundary from 'components/ErrorBoundary';

import {
  ConcurrencyInfo,
  toasterStyle,
  TOOLTIP_CONTAINER_ID,
} from './constants';

import './style.css';

function App() {
  return (
    <>
      <ReactTooltip id={TOOLTIP_CONTAINER_ID} html={true} />
      <Toaster containerStyle={toasterStyle} position="top-right" />
      <AppWithHeader>
        <Content />
      </AppWithHeader>
    </>
  );
}

export default App;

function AppWithHeader({ children }) {
  const total =
    useSelector((state) => state.concurrency?.concurrency?.data?.data?.total) ||
    0;
  const queued =
    useSelector(
      (state) => state.concurrency?.concurrency?.data?.data?.queued
    ) || 0;
  const occupied =
    useSelector(
      (state) => state.concurrency?.concurrency?.data?.data?.occupied
    ) || 0;

  const msftPlatformConcurrency =
    useSelector(
      (state) =>
        state.userInfo?.userInfo?.data?.organization?.plan_attributes
          ?.MAX_HYPEREXECUTE_PLATFORM_MSFT_CONCURRENCY
    ) || 0;
  //const isConcurrencyLoading = !concurrency.data || concurrency.data.loading;

  function getParallelTooltip() {
    return occupied > total && msftPlatformConcurrency > 0
      ? ParallelMessage.OVER_LIMIT.replace('COUNT', occupied - total)
      : ParallelMessage.UNDER_LIMIT;
  }

  const concurrencyToRender = ConcurrencyInfo.map((x) => ({ ...x }));
  // Set parallel info
  concurrencyToRender[0].runningCount = occupied;
  concurrencyToRender[0].total = total;
  concurrencyToRender[0].title = (
    <span data-tip={getParallelTooltip()} data-for={TOOLTIP_CONTAINER_ID}>
      Parallel
    </span>
  );
  // set queued info
  concurrencyToRender[1].runningCount = queued;
  concurrencyToRender[1].total = total;

  return (
    <LTCommonHeader
      customProductHeader={<CustomHeader />}
      concurrencyInfo={concurrencyToRender}
      showTunnel={true}
    >
      {children}
    </LTCommonHeader>
  );
}

function Content({ isOldHeader }) {
  const { promoBannerHeight } = usePlan();

  let className = 'main-section';

  className +=
    promoBannerHeight > 0
      ? ' newHeaderContentWrapperWithBanner'
      : ' newHeaderContentWrapper';

  return (
    <React.Suspense fallback={<Loader isSuspenseLoader={true} />}>
      <Router history={history}>
        <div className={className}>
          <AppBannerAndModals />
          <Routes history={history} isOldHeader={isOldHeader} />
        </div>
      </Router>
    </React.Suspense>
  );
}
